<app-streaming-chat-panel
  (click)="onConversationLinkClick($event)"
  [messages]="chatMessages"
  [isLoading]="isLoading"
  [emptyState]="emptyState"
  [config]="chatConfig"
  [queuedMessage]="queuedMessage"
  (sendMessage)="onSendMessage($event)"
  (newChat)="onNewChat()"
  (cancelRequest)="onCancelRequest()"
  (clearQueuedMessage)="onClearQueuedMessage()"
  (panelClose)="onPanelClose()"
  (messageActionClick)="onMessageActionClick($event)"
  (hitlApprovalClick)="onHitlApprovalClick($event.approval, $event.approved, $event.apiKey)"
>
  <ng-template #footerSlot>
    <ng-container
      *ngIf="contextDisplayComponent"
      [ngComponentOutlet]="contextDisplayComponent"
    ></ng-container>
  </ng-template>
</app-streaming-chat-panel>
